import Vue from 'vue'

export const EventBus = new Vue()


/***********************8
 *
 ventBus 又称为事件总线，在vue中可以使用它来作为沟通桥梁的概念,
 就像是所有组件共用相同的事件中心，可以向该中心注册发送事件或接收事件，
 所以组件都可以通知其他组件

 ************************/



// WEBPACK FOOTER //
// ./src/utils/event-bus.js